var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIconThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success icon component"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#4DC553"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.5952 13.396L17.1964 25.7948L11.5605 20.159",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIconThin);
export default __webpack_public_path__ + "static/media/SuccessIconThin.0e1a771e95601926de8f82169b7caaa4.svg";
export { ForwardRef as ReactComponent };